// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v68v","questions":"styles_questions__IhzBa","footer":"styles_footer__309Z1"};